import { useTranslation } from "react-i18next";
import Dialog from "../../../components/Dialog";
import Logo from "../../../assets/logo-2mm-header.png";
import { Link } from "react-router-dom";

const SharedCreateAccountDialog = ({
  uid,
  onClose,
}: {
  uid: string;
  onClose(): void;
}) => {
  const { t } = useTranslation(["organization"]);

  return (
    <Dialog
      className="--shared"
      onClose={() => {
        onClose();
      }}
    >
      <div className="popup_body lcol --center--h">
        <div>
          <img className="logo" src={Logo} alt="logo" />
        </div>
        <div className="intro --txt--center">
          {t("organization:shared-profile.dialog.WHY_CREATE_AN_ACCOUNT")}
        </div>
        <div className="lcol --center--h">
          <div className="primary-action">
            <Link
              type="submit"
              className="btn"
              to={`/register/organization?uid=${uid}`}
            >
              {t("organization:shared-profile.dialog.CREATE_AN_ACCOUNT")}
            </Link>
          </div>
          <div className="body--30 --strong">
            {t("organization:shared-profile.dialog.CATCH_PHRASE")}
          </div>
        </div>
        <div className="lrow">
          <button className="btn--2" onClick={onClose}>
            {t("organization:shared-profile.dialog.RESUME_VIDEO")}
          </button>
          <Link
            to={t("organization:shared-profile.UNCONNECTED_CTA_EXIT_LINK")}
            className="btn--grey"
            target="_blank"
          >
            {t("organization:shared-profile.dialog.MORE_DETAILS")}
          </Link>
        </div>
      </div>
    </Dialog>
  );
};

export default SharedCreateAccountDialog;
